import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="aloading-container">
      <div className="aloading-spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default Loading;
